import 'react';
import { PortalProvider } from '@cbhq/cds-web/overlays/PortalProvider';
import { jsx } from 'react/jsx-runtime';
const Provider = PortalProvider;
// eslint-disable-next-line @typescript-eslint/no-explicit-any -- TODO Fix this
function ModalProvider({
  children
}) {
  return /*#__PURE__*/jsx(Provider, {
    children: children
  });
}
export { ModalProvider };
//# sourceMappingURL=ModalWrapper.js.map
